export const EncodeObject = (object) => {
    const newObject = {};
    for (const [key, value] of Object.entries(object)) {
        newObject[key] = value;
    }
    return newObject;
}